// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2Kgwy","options":"AnswerScale_options__3tgwp","selected":"AnswerScale_selected__2PpVT"};